{
  "common.close": "Schließen",
  "common.athleteFallback": "Athlet {id}",
  "splash.title": "{app} — animierte Aktivitätsvisualisierung",
  "splash.tagline": "Deine Strava&nbsp;Daten in Bewegung",
  "splash.demo": "Demo",
  "tab.query.title": "Karte von {name}",
  "tab.query.heading": "Aktivitäten abfragen:",
  "tab.query.optDays": "letzte Tage",
  "tab.query.optActivities": "letzte Aktivitäten",
  "tab.query.optIds": "Aktivitäts-IDs",
  "tab.query.optDates": "Zeitraum",
  "tab.query.idsPlaceholder": "Aktivitäts-IDs hier eingeben",
  "tab.query.after": "Ab:",
  "tab.query.before": "Bis:",
  "tab.query.autozoom": "Nach dem Import automatisch auf die Abfrage zoomen <i class=\"hf hf-bullseye\"></i>",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Abfragen",
  "tab.query.createAccount": "Konto anlegen oder anmelden.",
  "tab.query.sports": "Sportarten:",
  "tab.query.allSports": "Alle Sportarten",
  "tab.query.sportsExcept": "Alle außer",
  "tab.query.sportsNone": "Keine",
  "tab.query.loadingSports": "Sportarten werden geladen…",
  "tab.query.sportsFailed": "Die Sportarten dieser Karte konnten nicht geladen werden",
  "tab.query.noSports": "Noch keine Aktivitäten",
  "tab.activities.title": "Angezeigte Aktivitäten",
  "tab.activities.clearSelection": "Auswahl aufheben",
  "tab.activities.renderSelected": "Auswahl anzeigen",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Auf Auswahl zoomen",
  "tab.controls.title": "Ebeneneinstellungen",
  "tab.controls.timescale": "Zeitskala <i>&tau;</i>",
  "tab.controls.timescaleHint": "Abspielgeschwindigkeit",
  "tab.controls.period": "Periode <i>T</i>",
  "tab.controls.periodHint": "Aktivität ~ Modell",
  "tab.controls.dotSize": "Punktgröße",
  "tab.controls.pathWidth": "Linienbreite",
  "tab.controls.pathWidthHint": "null blendet die Linien aus",
  "tab.controls.colors": "Farben",
  "tab.controls.colorsHint": "Palette drehen",
  "tab.controls.shadows": "Schatten",
  "tab.profile.loginTitle": "Anmelden",
  "tab.profile.anonNote": "Melde dich mit Strava an, um deine eigenen Aktivitäten zu sehen und dein Heatflask-Konto zu verwalten.",
  "tab.profile.loginLink": "Mit Strava anmelden",
  "tab.profile.editOnStrava": "Profil auf Strava bearbeiten",
  "tab.profile.indexNote": "Wir indizieren deine Aktivitätsübersichten, damit sie schnell verfügbar sind.",
  "tab.profile.viewIndex": "Index ansehen",
  "tab.profile.sharedMaps": "Geteilte Karten",
  "tab.profile.sharedMapsNote": "Aus: Nur du siehst deine Aktivitäten in Heatflask. An: Jeder mit einem Link zu deiner Karte sieht die Aktivitäten, die du auf Strava öffentlich gemacht hast. Deine privaten bleiben in jedem Fall nur für dich sichtbar. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">So funktioniert der Datenschutz</a>",
  "tab.profile.logout": "Abmelden",
  "tab.profile.deleteAccount": "Konto löschen",
  "tab.profile.deleteConfirm": "Dein Heatflask-Konto löschen?\n\nDamit werden deine indizierten Aktivitäten entfernt und Heatflask der Zugriff auf deine Strava-Daten entzogen. Das lässt sich nicht rückgängig machen.",
  "tab.profile.languageHeading": "Sprache",
  "tab.profile.languageAuto": "Automatisch",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Hilf uns, Übersetzungen zu verbessern oder neue hinzuzufügen!</a>",
  "tab.profile.unitsHeading": "Einheiten",
  "tab.profile.unitsAuto": "Automatisch",
  "tab.profile.unitsMetric": "Metrisch (km, m)",
  "tab.profile.unitsImperial": "Imperial (mi, ft)",
  "tab.profile.textSizeHeading": "Schriftgröße",
  "tab.profile.textSmaller": "Kleiner",
  "tab.profile.textReset": "Normal",
  "tab.profile.textLarger": "Größer",
  "tab.profile.mapDefaultsHeading": "Karten-Standard",
  "tab.profile.mapDefaultsNote": "Mit dieser Grundkarte, diesem Gelände und diesen Ebeneneinstellungen beginnen, wann immer du eine Karte öffnest, deren Link keine eigenen festlegt. Geteilte Links zeigen weiterhin genau das, was du siehst.",
  "tab.profile.mapDefaultsSave": "Als meinen Standard speichern",
  "tab.profile.mapDefaultsForget": "Vergessen",
  "tab.info.title": "Info",
  "tab.info.controlsHeading": "Steuerung",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + ziehen",
  "tab.info.shiftDragDesc": "Aktivitäten in einem Rechteck auswählen. Tippe auf einem Touchscreen zuerst auf <i class=\"hf-object-group\"></i> und ziehe dann mit einem Finger. Die zuletzt ausgewählte Aktivität zeigt ihre Details, und die Aktivitätsliste springt dorthin.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + ziehen",
  "tab.info.ctrlDragDesc": "Karte in 3D drehen und neigen, oder zwei Finger benutzen",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Seitenleiste öffnen oder schließen",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Vorheriger oder nächster Reiter",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Seitenleiste schließen",
  "tab.info.liveUrlHeading": "Live-URL",
  "tab.info.liveUrlDesc": "Kartenausschnitt und Animationseinstellungen stehen in der URL der Seite, sodass jeder, mit dem du sie teilst, dieselbe Ansicht sieht.",
  "tab.info.videoHeading": "Videoexport",
  "tab.info.videoDesc": "Die Schaltfläche <i class=\"hf-video-camera\"></i> nimmt die Animation als MP4 auf: antippen, das Rechteck über den gewünschten Kartenausschnitt ziehen und erneut antippen. Aufgenommen wird ein voller Durchlauf der Animation, damit sich das Video nahtlos wiederholt; dauert ein Durchlauf länger als {max} Sekunden (das längste Video, das Strava annimmt), wird bei {max} abgeschnitten.",
  "tab.info.contributeHeading": "Mitmachen",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Auf GitHub sponsern",
  "tab.info.contactsHeading": "Kontakt",
  "map.basemapAndTerrain": "Hintergrundkarte und Gelände",
  "map.pauseAnimation": "Animation anhalten",
  "map.resumeAnimation": "Animation fortsetzen",
  "capture.record": "Video aufnehmen ({period} s pro Durchlauf)",
  "capture.recordTruncated": "Video aufnehmen (ein Durchlauf dauert {period} s; nur die ersten {max} s werden aufgenommen)",
  "capture.recordArea": "Bereich im Rechteck aufnehmen",
  "capture.stop": "Aufnahme beenden",
  "capture.selectionTooSmall": "Auswahl ist zu klein",
  "capture.saved": "{name} gespeichert ({size})",
  "capture.cancelled": "Aufnahme abgebrochen",
  "capture.failed": "Aufnahme fehlgeschlagen: {error}",
  "capture.loadingEncoder": "Encoder wird geladen…",
  "capture.waitingForMap": "Warte auf die Karte…",
  "capture.encoding": "Kodiere… {percent} %",
  "capture.finalizing": "Wird abgeschlossen…",
  "share.title": "Link zu dieser Karte teilen",
  "share.copied": "Link kopiert",
  "share.copiedUnshared": "Link kopiert – aber deine Karte ist nicht geteilt, daher kann niemand sonst sie öffnen. Schalte „Geteilte Karten“ ein, um das zu ändern.",
  "share.unshared": "Deine Karte ist nicht geteilt, daher kann niemand sonst diesen Link öffnen. Schalte „Geteilte Karten“ ein, um das zu ändern.",
  "share.copyThis": "Diesen Link kopieren:",
  "update.available": "Eine neue Version von Heatflask ist verfügbar.",
  "update.reload": "Neu laden",
  "import.title": "Import läuft",
  "import.stop": "Stopp",
  "import.stopping": "wird gestoppt…",
  "import.contacting": "verbinde mit Strava…",
  "import.countOf": "Aktivitäten: {received} von {total}",
  "import.count": "Aktivitäten: {received}",
  "import.waitStrava": "Pausiert bis {time}: Stravas Download-Limit. Lass dieses Fenster offen; Neuladen macht es nicht schneller.",
  "import.waitRationed": "Deine schnellen Downloads für heute sind aufgebraucht. Der Rest geht um {time} langsamer weiter. Lass dieses Fenster offen.",
  "import.dailyLimit": "Stravas tägliches Download-Limit ist erreicht. Versuch es nach {time} erneut.",
  "import.dailyRationed": "Dein Anteil an Strava-Downloads für heute ist aufgebraucht. Versuch es nach {time} erneut.",
  "import.noActivitiesYet": "Dein Strava-Konto hat noch keine Aktivitäten. Zeichne eine auf Strava auf oder lade sie hoch, dann erscheint sie hier.",
  "table.noActivities": "keine Aktivitäten",
  "table.untitled": "(ohne Titel)",
  "activities.pageTitle": "{app} — Aktivitätsindex",
  "activities.heading": "Aktivitätsindex",
  "activities.fetching": "Aktivitäten werden geladen...",
  "activities.rateLimit": "Strava-Ratenlimit erreicht; weiter um {time}",
  "activities.noData": "Leider keine Daten &#128577;",
  "activities.colServerCache": "Track auf dem Server zwischengespeichert (Mongo)",
  "activities.colBrowserCache": "Track in diesem Browser zwischengespeichert",
  "activities.cachedServer": "Track für {id} ist auf dem Server zwischengespeichert",
  "activities.notCachedServer": "Track für {id} ist nicht auf dem Server zwischengespeichert",
  "activities.cachedBrowser": "Track für {id} ist in diesem Browser zwischengespeichert",
  "activities.notCachedBrowser": "Track für {id} ist nicht in diesem Browser zwischengespeichert",
  "sport.AlpineSki": "Ski alpin",
  "sport.BackcountrySki": "Skitour",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Basketball",
  "sport.Canoeing": "Kanu",
  "sport.Cricket": "Cricket",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Tanzen",
  "sport.EBikeRide": "E-Bike-Fahrt",
  "sport.Elliptical": "Crosstrainer",
  "sport.EMountainBikeRide": "E-Mountainbike-Fahrt",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Gravel-Fahrt",
  "sport.Handcycle": "Handbike",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Wanderung",
  "sport.IceSkate": "Eislaufen",
  "sport.InlineSkate": "Inlineskaten",
  "sport.Kayaking": "Kajak",
  "sport.Kitesurf": "Kitesurfen",
  "sport.MountainBikeRide": "Mountainbike-Fahrt",
  "sport.NordicSki": "Skilanglauf",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Physiotherapie",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Radfahrt",
  "sport.RockClimbing": "Klettern",
  "sport.RollerSki": "Rollski",
  "sport.Rowing": "Rudern",
  "sport.Run": "Lauf",
  "sport.Sail": "Segeln",
  "sport.Skateboard": "Skateboard",
  "sport.Snowboard": "Snowboard",
  "sport.Snowshoe": "Schneeschuhwandern",
  "sport.Soccer": "Fußball",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Stepper",
  "sport.StandUpPaddling": "Stand-up-Paddling",
  "sport.Surfing": "Surfen",
  "sport.Swim": "Schwimmen",
  "sport.TableTennis": "Tischtennis",
  "sport.Tennis": "Tennis",
  "sport.TrailRun": "Traillauf",
  "sport.Velomobile": "Velomobil",
  "sport.VirtualRide": "Virtuelle Radfahrt",
  "sport.VirtualRow": "Virtuelles Rudern",
  "sport.VirtualRun": "Virtueller Lauf",
  "sport.Volleyball": "Volleyball",
  "sport.Walk": "Spaziergang",
  "sport.WeightTraining": "Krafttraining",
  "sport.Wheelchair": "Rollstuhl",
  "sport.Windsurf": "Windsurfen",
  "sport.Workout": "Training",
  "sport.Yoga": "Yoga"
}
